import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GurullyDet } from "../../Action/GurullyAction";
import { useParams } from "react-router-dom";
import Loading from "../../Components/Loading";
import ErrorAlert from "../../Components/ErrorAlert";

export default function Gurully() {
  const [OpenNext, setOpenNext] = useState(false);
  const [AlertData, setAlertData] = useState({ msg: "", Alert: () => {} });
  const {
    detGurully,
    loading: loadingGurulyDet,
    error,
  } = useSelector((s) => s.GurullyDetReducer);
  const { PackageId } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GurullyDet(PackageId));
  }, [dispatch, PackageId]);

  useEffect(() => {
    if (error) {
      setOpenNext(true);
      setAlertData({
        msg: error,
        Alert: () => (window.location.href = "/dashboard"),
      });
    }
  }, [error]);

  return (
    <>
      {loadingGurulyDet ? <Loading /> : ""}
      <iframe
        src="https://api.testifyi.com/academygurully"
        style={{ width: "100%", height: "100vh", border: "none" }}
        title="Gurully Proxy"
      />
      <ErrorAlert
        OpenNext={OpenNext}
        setOpenNext={setOpenNext}
        AlertData={AlertData}
      />
    </>
  );
}
